import React from 'react';
import App from '../../../common/components/app';
import ChangeCategory from '../../../common/components/categories-link/change-category';
import CategoryDesktopHeader from '../../../common/components/category-desktop-header';
import CategoryMobileHeader from '../../../common/components/category-mobile-header';
import LoginScreen from '../../../common/components/login-screen';
import PopoverRoot from '../../../common/components/popovers/popover-root';
import { NotFoundPage } from '../../../common/containers/not-found-page';
import { type getCurrentMatch } from '../../../common/router/router-selectors';
import SearchDesktopHeader from '../../../search/containers/search-header/search-desktop-header';
import SearchMobileHeader from '../../../search/containers/search-header/search-mobile-header';
import SearchResultsPage from '../../../search/containers/search-results-page/search-results-page';
import MessageRoot from '../../components/messages/message-root';
import ModalRoot from '../../components/modals/modal-root';
import {
  ROUTE_404,
  ROUTE_ARCHIVE,
  ROUTE_CATEGORIES,
  ROUTE_CATEGORY,
  ROUTE_HASHTAG,
  ROUTE_HOME,
  ROUTE_LOGIN,
  ROUTE_SEARCH,
  ROUTE_TAGS,
} from '../../constants/routes';

import ArchivePage from '../archive-page';
import CategoryPage from '../category-page';
import FeedPage from '../feed-page';
import HashtagPage from '../hashtag-page';
import TagsPage from '../tags-page';

type RouteProps = Pick<ReturnType<typeof getCurrentMatch>, 'params'>;

const WrapComponent = (Component: React.FC<{ params: any }>) => {
  return (props: RouteProps) => (
    <App
      main={<Component params={props.params} />}
      modalRoot={<ModalRoot />}
      messageRoot={<MessageRoot />}
      popoverRoot={<PopoverRoot />}
      mobileHeader={<CategoryMobileHeader menu={<ChangeCategory />} />}
      desktopHeader={<CategoryDesktopHeader />}
    />
  );
};

export const ROUTE_COMPONENT_MAP = {
  [ROUTE_404]: WrapComponent(NotFoundPage),
  [ROUTE_LOGIN]: WrapComponent(LoginScreen),
  [ROUTE_CATEGORIES]: WrapComponent(CategoryPage),
  [ROUTE_CATEGORY]: WrapComponent(CategoryPage),
  [ROUTE_HASHTAG]: WrapComponent(HashtagPage),
  [ROUTE_ARCHIVE]: WrapComponent(ArchivePage),
  [ROUTE_TAGS]: WrapComponent(TagsPage),
  [ROUTE_SEARCH]: (props: RouteProps) => (
    <App
      main={<SearchResultsPage params={props.params} />}
      mobileHeader={<SearchMobileHeader params={props.params} />}
      desktopHeader={<SearchDesktopHeader params={props.params} />}
    />
  ),
  [ROUTE_HOME]: WrapComponent(FeedPage),
} as const;
